import React, { useEffect, useState } from 'react'
import * as global from '../../constants/global'
import CommonTable from '../common-module/CommonTable';
import { getRequestForApi } from '../../utility-files/api-util/CommonRequest';
import { callHttpRequest, methodType } from '../../utility-files/api-util/HttpRequest';
import { isBooleanValue, isStringValue } from '../../utility-files/data-util/DataHandling';
import NoRecord from '../common-module/NoRecord';
import AddItemConfig from '../../custom-popup-model/AddItemConfig';
import { useAlert } from 'react-alert';
import { alertTypes } from '../../utility-files/helper-function/HelperFunction';
import CustomLoader from '../../custom-ui/CustomLoader';
import { getDateFormat, getTimeFormat } from '../../utility-files/date-util/DateHandling';
import Image from '../common-module/Image';
import { IMAGE_TYPES } from '../../utility-files/default-values/DefaultValues';
import ComponentHandler from '../common-module/ComponentHandler';
import ThemeButton from '../../qed-theme-module/ThemeButton';
import DeleteConfig from '../../custom-popup-model/DeleteConfig';
import { alertMessages } from '../../utility-files/helper-function/HelperFunction';
import TableContentHandler from '../../qed-theme-module/TableContentHandler';
import { useSelector } from 'react-redux';

function ItemConfiguration() {
  const alert = useAlert()
  const [isShowModel, setIsShowModel] = useState(false);
  const [configurationId, setconfigurationId] = useState(null);
  const [itemConfigModelType, setItemConfigModelType] = useState("");
  const [itemList, SetItemList] = useState(null);
  const [configList, setConfigList] = useState(null);
  const [pending, setPending] = useState(false);
  const [itemData, setItemData] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteItemConfig, setDeleteItemConfig] = useState(null);
  const walletData = useSelector((state) => state.reduxReducer.walletData);

  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = async () => {
    setPending(true)
    let variables = {}, res;
    let request = getRequestForApi(global.LIST_ITEM_CONFIGURATION, variables, methodType.POST);
    await callHttpRequest(request).then(response => {
      if (response?.status === 201) {
        res = response?.data?.response?.data
        SetItemList(res);
        setPending(false);
      };
    }).catch((err) => {
      alert.show(err?.response?.data?.message, { type: alertTypes.ERROR });
      setPending(false);
    });
  };

  const getConfigurationDetails = async (row) => {
    setPending(true)
    let variables = {}, res, request;
    variables['configurationId'] = isStringValue(row?.id);
    request = getRequestForApi(global.UPDATE_CONFIGURATION_DETAIL, variables, methodType.POST);
    await callHttpRequest(request).then(response => {
      if (response?.status === 201) {
        res = response?.data?.response?.data
        setConfigList(res);
        setItemData(res);
        setPending(false);
      } else {
        alert.show(response?.data, { type: alertTypes.ERROR });
        setPending(false);
      }
    }).catch((err) => {
      alert.show(err?.response?.data?.message, { type: alertTypes.ERROR });
      setPending(false);
      console.log("err", err);
    });
  };

  const handleConfig = () => {
    if (isStringValue(walletData?.userSubscriptionStatus)?.toLowerCase() === 'active') {
      setIsShowModel(!isShowModel)
      setItemConfigModelType('Add')
    } else {
      alert.show('Your subscription has expired. Please renew subscription to use Item configuration.', { type: alertTypes.ERROR });
    };
  };

  const handleCreate = (row) => {
    setIsEditMode(true);
    setIsShowModel(true);
    setconfigurationId(row?.id);
    getConfigurationDetails(row);
    setItemConfigModelType('Edit')
  };

  const deleteConfig = async () => {
    setPending(true);
    let variables = {};
    variables.id = isStringValue(deleteItemConfig.id);
    let request = getRequestForApi(
      global.INACTIVATE_ITEM_CONFIGURATION,
      variables,
      methodType.POST
    );
    await callHttpRequest(request)
      .then((response) => {
        if (response?.status === 201 && response?.data?.error === 201) {
          alert.show(alertMessages.ITEM_CONFIG_DELETE_SUCCESS, {
            type: alertTypes.SUCCESS,
          });
          setDeleteItemConfig(null);
          getItemList();
        } else {
          alert.show(response?.data?.response?.data, {
            type: alertTypes.SUCCESS,
          });
        }
        setPending(false);
      })
      .catch((err) => {
        alert.show(err?.response?.data?.message, { type: alertTypes.ERROR });
        setPending(false);
        console.log("err", err);
      });
  };

  const configurationColumns = [
    {
      name: <TableContentHandler header={'Name'} />,
      selector: row => row?.name,
      sortable: true,
      cell: row => (<TableContentHandler data={row?.name} />),
    },
    {
      name: <TableContentHandler header={'Created By'} />,
      selector: row => row?.createBy,
      sortable: true,
      cell: row => (<TableContentHandler data={row?.createBy} />),
    },
    {
      name: <TableContentHandler header={'Organization'} />,
      selector: row => row?.organisation,
      sortable: true,
      cell: row => (<TableContentHandler data={row?.organisation} />),
    },
    {
      name: <TableContentHandler header={'Create Date'} />,
      selector: row => row?.createDate,
      sortable: true,
      cell: row => (<TableContentHandler data={`${getDateFormat(row?.createDate)} ${getTimeFormat(row?.createDate)}`} />),
    },
    {
      name: <TableContentHandler header={'Update Date'} />,
      selector: row => row?.updateDat,
      sortable: true,
      cell: row => (<TableContentHandler data={`${getDateFormat(row?.updateDat)} ${getTimeFormat(row?.updateDat)}`} />),
    },
    {
      name: <TableContentHandler header={'Status'} />,
      selector: row => row?.status,
      sortable: true,
      cell: row => (<span data-tooltip={isBooleanValue(row?.status)}>
        <span className='ellipsis'>
          {isBooleanValue(row?.status) ?
            <span className="logged-in">●</span> :
            <span className="logged-out">●</span>}
        </span>
      </span>),
    },
    {
      name: <TableContentHandler header={"Actions"} />,
      selector: row => row?.id,
      cell: row => (
        <>
          <Image
            className="quick-link-content-icon"
            src={IMAGE_TYPES.ARROW_RIGHT}
            onMouseOver={e => e.currentTarget.src = IMAGE_TYPES.SELECTED_ARROW}
            onMouseOut={e => e.currentTarget.src = IMAGE_TYPES.ARROW}
            alt={row?.id}
            onClick={() => {
              setIsShowModel(!isShowModel);
              setconfigurationId(row?.id);
              setItemConfigModelType('View')
            }}
          />

          {row?.status === true && (
            <Image
              className="me-3"
              src={IMAGE_TYPES.PENCIL_IMAGE}
              alt="Edit"
              onClick={() => handleCreate(row)}
            />
          )}

          {row?.status === true && (
            <Image
              className="pointer delete"
              src={IMAGE_TYPES.TRASH_RED}
              alt="Delete"
              onClick={() => setDeleteItemConfig(row)}
            />
          )}
        </>
      )
    }

  ];
  return (
    <>
      <ComponentHandler>
        <div className="box table_structure item-data-table">
          <div className="actionRow">
            <div className="left">
              <ThemeButton className="addButton pointer" onClick={() => handleConfig()}>
                <i className="bi bi-plus-circle"></i>Add Item Configuration
              </ThemeButton>
            </div>
          </div>
          <CommonTable
            columns={configurationColumns}
            data={itemList}
            fixedHeader={true}
            fixedHeaderScrollHeight={'300px'}
            progressPending={pending}
            progressComponent={<CustomLoader />}
            noDataComponent={<NoRecord />}
            onRowClicked={(row) => {
              setIsShowModel(!isShowModel); setconfigurationId(row?.id);
            }}
          />
        </div>
      </ComponentHandler>
      <AddItemConfig isShowModel={isShowModel} setIsShowModel={setIsShowModel} isEditMode={isEditMode} configurationId={configurationId} setconfigurationId={setconfigurationId} onSuccess={getItemList} configDetails={itemData} setIsEditMode={setIsEditMode} setItemConfigModelType={setItemConfigModelType} itemConfigModelType={itemConfigModelType} />
      <DeleteConfig deleteConfigModal={deleteItemConfig} heading={"Are you sure you want to delete this Configuration"} handleSubmit={deleteConfig} handleClose={setDeleteItemConfig} />
    </>
  )
}

export default ItemConfiguration
